import { Check, Loader } from 'lucide-react';

import { ApplicationTimeline, type TimelineEvent } from './_shared/ApplicationTimeline';

interface PendingTimelineStepProps {
  label: string;
}

export function PendingTimelineStep({ label }: PendingTimelineStepProps) {
  const events: readonly TimelineEvent[] = [
    { icon: Check, label: `${label} Submitted` },
    { icon: Loader, label: `${label} Under Review` },
  ];

  return <ApplicationTimeline events={events} />;
}
